import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Drivers.css';
import SearchBar from '../Components/search';
import Typography from '@mui/material/Typography';



const Home = (Comps) => {
    let compTemp = Comps['driverApps']
    let compTemp2 = compTemp.concat(Comps['backSeatApps'])
    let compsTemp = compTemp2.concat(Comps['bookingApps'])
    let compsNew = [];
    let ids = {}


    compsTemp.forEach(obj=> {
        if (!ids[obj.iAffiliateID]){
            ids[obj.iAffiliateID] = true;
            compsNew.push(obj);
        }
    });

    const filterComps = (compsNew, query) => {
            if (!query.toLowerCase()) {
                return compsNew;
            }

            return compsNew.filter((comp) => {
                const compName = comp.name.toLowerCase();
                return compName.includes(query.toLowerCase());
            })
    }

    const { search } = window.location;
    const query = new URLSearchParams(search).get('name', 'other');
    const [searchQuery, setSearchQuery] = useState(query || '');
    const filteredComps = filterComps(compsNew, searchQuery);

    addAnimation();
  
  function addAnimation() {
      document.querySelectorAll(".scroller").forEach(scroller => {
        const inner   = scroller.querySelector(".scroller_inner");
        const titleEl = inner.querySelector(".mainPageh2");
    
        // check if the text overflows its container
        if (titleEl.scrollWidth > scroller.clientWidth) {
          // mark it for CSS margin + animation
          titleEl.classList.add("overflowing");
          scroller.setAttribute("data-animated", "true");
    
          // duplicate items for seamless scroll
          Array.from(inner.children).forEach(item => {
            const dup = item.cloneNode(true);
            dup.setAttribute("aria-hidden", "true");
            inner.appendChild(dup);
          });
        }
      });
    }

    useEffect(() => {
          addAnimation();
      }, [filteredComps]);

    return (
        <div className='mainPage'>
            <SearchBar
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}/>

            <Typography
                variant="h3"
                component="h1"
                sx={{ textAlign: 'center', mb: 3,  }}
            >
                ITCurves App Store
            </Typography>
                <ul className='appRows'>
                <div className = "flex-row">
                    {filteredComps?.map(comp => (
                        <li key = {comp.key}>
                            <div className ="col">
                                <figure className = "gallery__item">
                                <div className = "scroller" data-speed="fast">
                                    <div className ="scroller_inner">
                                        <h2 className="mainPageh2">{comp.name}</h2>
                                    </div>
                                </div>
                                
                                    <Link to={comp.navLink}>
                                        <img src ={comp.appLogo} className={'gallery__img'} alt = {comp.name}></img>
                                    </Link>
                                </figure>
                            </div>
                        </li>
                    ))}
                    </div>
                </ul>
        </div>
    )
};

export default Home;